export const CONTACT = {
  phone: "9990905807",
  phoneAlt: "9919991877",
  hello: "hello@plotbysquare.com",
  info: "info@plotbysquare.com",
  career: "career@plotbysquare.com",
  admin: "admin@plotbysquare.com",
  business: "himanshu@plotbysquare.com",
};
export const fmtPhone = (n) => `+91 ${n.slice(0, 5)} ${n.slice(5)}`;
export const tel = (n) => `tel:+91${n}`;
